import axios from 'axios';

import router from '@/router';
import store from '@/store';
import { tokenName } from '@/use/useAuth';

export default function useAxios() {
  const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_HOST || 'https://backend.panicom.ideavivat-demo.com',
  });

  if (localStorage.getItem(tokenName)) {
    axiosInstance.defaults.headers.common = { Authorization: `Bearer ${localStorage.getItem(tokenName)}`, Accept: 'application/json' };
  } else if (sessionStorage.getItem(tokenName)) {
    axiosInstance.defaults.headers.common = { Authorization: `Bearer ${sessionStorage.getItem(tokenName)}`, Accept: 'application/json' };
  }
  // if (localStorage.getItem(tokenName) || sessionStorage.getItem(tokenName)) {
  //   axiosInstance.post('/api/auth/refresh').then((result: any) => {
  //     if (result.data.access_token) {
  //       axiosInstance.defaults.headers.common = { Authorization: `Bearer ${result.data.access_token}`, Accept: 'application/json' };
  //       localStorage.setItem(tokenName, result.data.access_token);
  //     }
  //   });
  // }

  axiosInstance.interceptors.response.use((response) => {
    if (response.status === 401) {
      console.log('status 401');
    }
    return response;
  }, (error) => {
    if ((error.message) || (error.response && error.response.data)) {
      if (error.message === 'Request failed with status code 403') {
        store.commit('setUnauthorizeModal', true);
      } else if (error.toJSON().message === 'Network Error' && error.toJSON().code === undefined) {
        // TODO
      } else if (error.message === 'Network Error'
        && (
          error.response.data.status === 'Token is Expired'
          || error.response.data.status === 'Token is Invalid'
          || error.response.data.message === 'Unauthenticated.'
        )
      ) {
        if (localStorage.getItem(tokenName)) {
          localStorage.removeItem(tokenName);
          localStorage.removeItem(`${tokenName}-expire`);
        }
        if (sessionStorage.getItem(tokenName)) {
          sessionStorage.removeItem(tokenName);
          sessionStorage.removeItem(`${tokenName}-expire`);
        }
        if ((router as any).apps[0]._route.name !== 'Login') {
          console.error(error.toJSON());
          router.push({ name: 'Login' });
        }
      }
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error.message);
  });

  const setAuthorization = async (token: string) => {
    axiosInstance.defaults.headers.common = { Authorization: `Bearer ${token}`, Accept: 'application/json' };
    if (token !== '') {
      localStorage.setItem(tokenName, token);
    }
    return true;
  };

  const removeAuthorization = async () => {
    axiosInstance.defaults.headers.common = { Authorization: 'Bearer' };
    localStorage.removeItem(tokenName);
    return true;
  };

  return {
    axios: axiosInstance,
    setAuthorization,
    removeAuthorization,
  };
}
